/* eslint-disable import/no-default-export */
import { Action, actionCreator, createReducer } from '@trello/redux';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';
import { UtmCampaign } from 'app/gamma/src/util/cross-flow-essentials';
// Action types

const SET_OVERLAY = Symbol('ui/SET_OVERLAY');
const REMOVE_OVERLAY = Symbol('ui/REMOVE_OVERLAY');
const SET_OVERLAY_CONTEXT = Symbol('ui/SET_OVERLAY_CONTEXT');

export enum OverlayType {
  CreateBoard = 'create_board',
  ClosedBoards = 'closed_boards',
  CreateTeam = 'create_team',
  ProductStore = 'product_store',
  CrossFlow = 'cross_flow',
  PlanSelection = 'plan-selection',
}

export interface OverlayContext {
  orgId?: string;
  source?: string;
  campaign?: UtmCampaign;
}

type SetOverlayAction = Action<
  typeof SET_OVERLAY,
  {
    overlayType: OverlayType | null;
    teamType?: TeamType | null;
    productKey?: string | null;
    context?: OverlayContext;
  }
>;
type RemoveOverlayAction = Action<typeof REMOVE_OVERLAY, null>;
type SetOverlayContextAction = Action<
  typeof SET_OVERLAY_CONTEXT,
  OverlayContext
>;

interface OverlayPayload {
  overlayType: string | null;
  teamType: TeamType | null;
  productKey: string | null;
  context: OverlayContext;
}

export type OverlayState = OverlayPayload;

// Reducer
const initialState: OverlayState = {
  overlayType: null,
  teamType: null,
  productKey: null,
  context: {},
};

export default createReducer(initialState, {
  [SET_OVERLAY](state: OverlayState, { payload }: SetOverlayAction) {
    return payload;
  },
  [SET_OVERLAY_CONTEXT](
    state: OverlayState,
    { payload }: SetOverlayContextAction,
  ) {
    return {
      ...state,
      context: payload,
    };
  },
  [REMOVE_OVERLAY]() {
    return initialState;
  },
});

// Action creators
export const setOverlay = actionCreator<SetOverlayAction>(SET_OVERLAY);
export const removeOverlay = actionCreator<RemoveOverlayAction>(REMOVE_OVERLAY);
export const setOverlayContext = actionCreator<SetOverlayContextAction>(
  SET_OVERLAY_CONTEXT,
);
